import Card from '@/components/atoms/Card';

import ProductCardBestFor from './ProductCardBestFor';
import ProductCardButton from './ProductCardButton';
import ProductCardDescription from './ProductCardDescription';
import ProductCardFeatures from './ProductCardFeatures';
import ProductCardTitle from './ProductCardTitle';
import ProductCardWithUseCases from './ProductCardWithUseCases';
import { ProductCardProps } from './types';
import { cn } from '@/lib/utils';

export default function ProductCard(
  props: ProductCardProps & { className?: string }
) {
  if (props.useCases?.length) {
    return <ProductCardWithUseCases {...props} />;
  }

  const {
    icon,
    title,
    subtitle,
    description,
    bestFor,
    features,
    button,
    className,
  } = props;

  return (
    <Card
      classNames={{
        root: cn(
          'h-full rounded-md flex flex-col text-left border-brand-300 dark:border-brand-700 shadow-sm dark:shadow-none bg-base-white',
          className
        ),
      }}
    >
      <ProductCardTitle icon={icon} title={title} subtitle={subtitle} />
      <ProductCardDescription description={description} />
      {bestFor && <ProductCardBestFor bestFor={bestFor} />}
      {!!features?.length && <ProductCardFeatures features={features} />}
      {button && <ProductCardButton button={button} />}
    </Card>
  );
}
